import axios from "./AxiosClient";

const url = `/api`;

const FilesUploadService = {
  uploadFile: (formData) => {
    return axios.post(
      `${url}/file/upload/pdf`,
      formData,

      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },
  uploadFileImage: (formData) => {
    return axios.post(
      `${url}/file/upload`,
      formData,

      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },
  uploadFileBase64: (formData) => {
    return axios.post(`${url}/image/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  downloadFile: (fileName) => {
    return axios.get(`${url}/file/download/${fileName}`, {
      responseType: "blob", // important to handle binary data
    });
  },
};

export default FilesUploadService;
